import { render, staticRenderFns } from "./ValueChain.vue?vue&type=template&id=d4b3990c&scoped=true"
import script from "./ValueChain.vue?vue&type=script&lang=js"
export * from "./ValueChain.vue?vue&type=script&lang=js"
import style0 from "./ValueChain.vue?vue&type=style&index=0&id=d4b3990c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4b3990c",
  null
  
)

export default component.exports